import { CountBadge, IconButton } from '@vrplatform/components';
import { useIntercom, useTeam } from '@vrplatform/data';
import { CommentQuestionIcon } from '@vrplatform/icons';
import { Group, Text, rem, useMantineTheme } from '@mantine/core';
import { useNavbarExpanded } from '../../../hooks';

export const NavbarSupportButton = () => {
  const [{ isGL: GL }] = useTeam();
  const { unreadMessagesCount } = useIntercom();

  const { colors } = useMantineTheme();

  const color = colors.neutral[0];

  const { isDesktopExpanded } = useNavbarExpanded();

  if (GL) {
    return (
      <IconButton
        onClick={undefined}
        id="intercom-widget"
        icon="CommentQuestionIcon"
        iconSize={18}
        color={(theme) => theme.colors.neutral[3]}
        count={unreadMessagesCount}
        tooltip="Help & Support"
      />
    );
  }

  return (
    <Group
      // onClick={toggle}
      id="intercom-widget"
      gap="xs"
      mx="xs"
      px={'xs'}
      py={5}
      sx={(theme) => ({
        marginBottom: rem(5),
        cursor: 'pointer',
        transition: 'background-color 0.1s ease-in-out',
        justifyContent: isDesktopExpanded ? undefined : 'center',
        borderRadius: theme.radius.md,
        ':active': {
          transform: 'translateY(1px)',
        },
        ':hover': {
          backgroundColor: theme.colors[theme.primaryColor][9] + 40,
        },
      })}
    >
      <CommentQuestionIcon size={18} color={color} />
      {isDesktopExpanded && (
        <>
          <Text c={color} component="span" size={'sm'}>
            Help & Support
          </Text>
          {unreadMessagesCount ? (
            <CountBadge
              count={unreadMessagesCount}
              size={'0.75rem'}
              sx={{
                marginLeft: 'auto',
              }}
            />
          ) : null}
        </>
      )}
    </Group>
  );
};
